// extracted by mini-css-extract-plugin
export default {"header":"styles_header__eIYkS","title":"styles_title__BpZ-E","rateWrap":"styles_rateWrap__av-ui","headerWrap":"styles_headerWrap__4lXSc"};